import React, { forwardRef, memo } from 'react';
import { SvgIcon } from '../SvgIcon';
export var createSvgIcon = function createSvgIcon(path, displayName) {
  var Component = memo(forwardRef(function (props, ref) {
    return React.createElement(SvgIcon, Object.assign({}, props, {
      ref: ref
    }), path);
  }));
  Component.displayName = "".concat(displayName, "Icon");
  return Component;
};